import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "./store"

export const attendeeSlice = createSlice({
  initialState: {
    attendees: [] as Attendee[],
  },
  name: "attendee",
  reducers: {
    selectAttendees: (state, { payload }: PayloadAction<Attendee[]>) => {
      return { attendees: payload }
    },
  },
})

export const { selectAttendees } = attendeeSlice.actions

export const attendeeSelector = ({ attendee }: RootState) => attendee
